import React, { Component } from 'react';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'

import Container from 'react-bootstrap/Container';
import { Link, Navigate  } from "react-router-dom";
import AuthService from './AuthService';
import './Events.css'
import 'bootstrap/dist/css/bootstrap.min.css';

class Admins extends Component {
  state = { items: [] }

  componentDidMount() {
    const bearerToken = new AuthService().getToken();
    if(bearerToken != null) {
      window.fetch(process.env.REACT_APP_EVENTS + '/tokens', {
        method: 'GET',
        headers: {
          Authorization: bearerToken
        }
      }).then(data => {
        data.json().then(res => {
          this.setState({ items: res })
        })
      })
    }
  }
  
  handleInvalidateToken = (jti) => {
    if (window.confirm('Are you sure you want to invalidate this token?')) {
      const bearerToken = new AuthService().getToken();
      if(bearerToken != null) {
        fetch(process.env.REACT_APP_EVENTS + '/invalidate', {
          method: 'POST',
          headers: {
            Authorization: bearerToken,
		    'Content-Type':'application/json',
          },
	      body: JSON.stringify({
	        "jti": jti
	      }),
        })
          .then((response) => {
            if (response.status === 204) {
			  const nextItems = this.state.items.map(item => {
				      if (item.jti === jti) {
					    return {
						  ...item,
						  jti: null,
						  exp: null,
						  jwt: null,
						}	  
				      } else {
					    return item;
				      }
				    });
			  this.setState({ items: nextItems });
            } else {
              throw new Error('Failed to invalidate token');
            }
          })
          .catch((error) => {
            console.error(error);
          });
      }

    }
  }
  
  handleMakeToken = (email) => {
    if (window.confirm('Are you sure you want to create a token?')) {
      const bearerToken = new AuthService().getToken();
      if(bearerToken != null) {
        fetch(process.env.REACT_APP_EVENTS + '/maketoken', {
          method: 'POST',
          headers: {
            Authorization: bearerToken,
		    'Content-Type':'application/json',
          },
	      body: JSON.stringify({
	        "email": email
	      }),
        })
		.then((response) => response.status === 200 ? response.json() : null)
		  .then(user => {
  			if(user != null) {
			  const nextItems = this.state.items.map(item => {
  				      if (item.email === email) {
  					    return {
  						  ...item,
  						  jti: user.jti,
  						  exp: user.exp,
  						  jwt: user.jwt,
  						}	  
  				      } else {
  					    return item;
  				      }
  				    });
  			  this.setState({ items: nextItems });
		    }
          })
          .catch((error) => {
            console.error(error);
          });
      }

    }
  }
  
  render() {
    if((new AuthService()).loggedIn()) {
    return (
      <>
      <Container>
        <style>
            {`
              th {
                text-align: center;
                width: auto;
              }
              table {
                table-layout: auto;
                width: auto;
              }
            `}
        </style>
        <Table striped bordered>
          <thead>
            <tr><th colSpan="4">{this.state.items.length} total tokens</th><th><Link to='/'>events</Link>&nbsp;&nbsp;&nbsp;&nbsp;<Link to='/logout'>logout</Link></th></tr>
            <tr>
              <th>email</th>
              <th>can download?</th>
              <th>jti</th>
              <th>exp</th>
			  <th>actions</th>
            </tr>
          </thead>
          <tbody>
          {this.state.items.sort((a,b) => {
            let acreated = a.created_at
            let bcreated = b.created_at
            if (a.created_at > new Date().toISOString()) a.created_at = acreated;
            if (b.created_at > new Date().toISOString()) b.created_at = bcreated;
            if (b.created_at < a.created_at) return -1;
            if (a.created_at < b.created_at) return 1;
            return 0;
          }).map((item) => {
            return (
            <tr key={item.id}>
              <td>{item.email}</td>
              <td>{item.candownload ? 'true' : 'false'}</td>
              <td>{item.jti}
			    {item.jti != null ? ( <div onClick={() => {navigator.clipboard.writeText(item.jwt)}} className="shareicon" >(click HERE to copy JWT token to clipboard)</div> ) : ('')}
			  </td>
              <td>{item.exp}</td>
			  <td>
				{item.jti != null ? (
					<OverlayTrigger
			        	delay={{ hide: 450, show: 300 }}
			        	overlay={(props) => (
			          	  <Tooltip {...props}>
			            	Invalidate current token
			          	  </Tooltip>
			        	)}
			        	placement="bottom"
			      	  >
					<Button variant="danger" onClick={() => this.handleInvalidateToken(item.jti)}><span aria-hidden="true">&times;</span></Button>
					</OverlayTrigger>
				) : 
				(
					<OverlayTrigger
		        		delay={{ hide: 450, show: 300 }}
		        		overlay={(props) => (
		          	  	  <Tooltip {...props}>
		            		Create a JWT token
		          	  	  </Tooltip>
		        		)}
		        		placement="bottom"
		      	  	  >
					<Button variant="success" onClick={() => this.handleMakeToken(item.email)}><span aria-hidden="true">&#10004;</span></Button>
					</OverlayTrigger>
				)}
			  </td>
            </tr>);})}
          </tbody>
        </Table>
      </Container>
      </>
    )
  }
  return (
    <Navigate to='/login' />
  )
  }
}

export default Admins
